import { createFileRoute } from '@tanstack/react-router';
import { Card } from '@/ui/primitives';
import { PageShell } from '@/ui/layout';
import { useDashboardExecutive } from '@/modules/dashboard/api';
import { useMetricas } from '@/modules/crm/api';
import { ExecDashboard } from '@/modules/dashboard/components/ExecDashboard';

export const Route = createFileRoute('/_authed/dashboard')({
  component: DashboardPage,
});

// Seletor de período — Mês é o único com dado hoje (backend compara mês corrente
// vs anterior). Trimestre/Ano ficam sinalizados como próximos.
function PeriodPills() {
  return (
    <div className="flex items-center gap-0.5 rounded-full border border-border bg-elevated p-[3px] dark:border-transparent">
      <span className="rounded-full bg-[var(--accent)] px-3.5 py-1.5 text-[12.5px] font-medium text-[var(--on-solid)]">
        Mês
      </span>
      <span className="cursor-not-allowed px-3.5 py-1.5 text-[12.5px] font-medium text-text-muted" title="Em breve">
        Trimestre
      </span>
      <span className="cursor-not-allowed px-3.5 py-1.5 text-[12.5px] font-medium text-text-muted" title="Em breve">
        Ano
      </span>
    </div>
  );
}

function DashboardPage() {
  const { data, isLoading, error } = useDashboardExecutive();
  const { data: metricas } = useMetricas();

  if (isLoading) {
    return (
      <PageShell title="Dashboard" titleSize="compact">
        <Card padding="lg">
          <p className="text-sm text-text-muted">Carregando indicadores…</p>
        </Card>
      </PageShell>
    );
  }

  if (error || !data) {
    return (
      <PageShell title="Dashboard" titleSize="compact">
        <Card padding="lg">
          <p className="text-sm text-danger">Falha ao carregar dashboard executivo.</p>
        </Card>
      </PageShell>
    );
  }

  const oportunidadesAtivas = metricas?.ativos_por_frente?.reduce((s, f) => s + Number(f.qtd), 0) ?? 0;

  return (
    <PageShell title="Dashboard" titleSize="compact" actions={<PeriodPills />}>
      <ExecDashboard
        data={data}
        receitaFechada={metricas?.ganhos?.valor ?? 0}
        negociosFechados={metricas?.ganhos?.qtd ?? 0}
        oportunidadesAtivas={oportunidadesAtivas}
        pipelineBruto={metricas?.pipeline_valor_bruto ?? 0}
        ganhosMes={metricas?.ganhos?.qtd ?? 0}
      />
    </PageShell>
  );
}
